import React from "react";
import { NavDropdown } from "react-bootstrap";
import { useLanguage } from "../context/LanguageContext";

const languages = [
  { code: "hr", label: "Hrvatski", flag: "🇭🇷", note: "Glavni" },
  { code: "en", label: "English", flag: "🇬🇧", note: "AI Translation" },
  { code: "zh", label: "中文", flag: "🇨🇳", note: "AI 翻译" },
];

const LanguageSelector = ({ isMobile = false }) => {
  const { language, setLanguage, t } = useLanguage();

  const currentLang = languages.find((l) => l.code === language) || languages[0];

  const titleContent = (
    <span
      className="d-inline-flex align-items-center gap-1 px-2 py-1"
      style={{
        borderRadius: "20px",
        backgroundColor: "rgba(255, 255, 255, 0.08)",
        border: "1px solid rgba(255, 255, 255, 0.15)",
        fontSize: "0.88rem",
        fontWeight: "600",
        color: "#ffffff",
      }}
    >
      <span style={{ fontSize: "1rem" }}>{currentLang.flag}</span>
      <span>{currentLang.code.toUpperCase()}</span>
    </span>
  );

  return (
    <NavDropdown
      title={titleContent}
      id={`language-nav-dropdown${isMobile ? "-mobile" : ""}`}
      className="language-selector-dropdown"
      align="end"
    >
      <div className="px-3 py-2 text-muted small border-bottom mb-1" style={{ fontSize: "0.75rem", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px" }}>
        {t("nav.languageSelect")}
      </div>
      {languages.map((l) => (
        <NavDropdown.Item
          key={l.code}
          onClick={() => setLanguage(l.code)}
          active={l.code === language}
          className="d-flex align-items-center justify-content-between py-2"
          style={{ minWidth: "190px", fontSize: "0.92rem" }}
        >
          <span className="d-flex align-items-center gap-2">
            <span style={{ fontSize: "1.15rem" }}>{l.flag}</span>
            <span style={{ fontWeight: l.code === language ? "700" : "500" }}>{l.label}</span>
          </span>
          <span
            className="badge rounded-pill"
            style={{
              fontSize: "0.7rem",
              backgroundColor: l.code === "hr" ? "rgba(101, 115, 182, 0.15)" : "rgba(119, 114, 241, 0.2)",
              color: l.code === "hr" ? "#6573b6" : "#7772f1",
              fontWeight: "600",
              marginLeft: "10px",
            }}
          >
            {l.note}
          </span>
        </NavDropdown.Item>
      ))}
      <NavDropdown.Divider />
      <div className="px-3 py-2 text-muted" style={{ fontSize: "0.75rem", maxWidth: "230px", lineHeight: "1.3" }}>
        <span style={{ color: "#7772f1", fontWeight: "700" }}>🤖 AI: </span>
        {t("aiNotice.dropdownNotice")}
      </div>
    </NavDropdown>
  );
};

export default LanguageSelector;
